import {graphql, compose} from "react-apollo";
import gql from 'graphql-tag';

import { gq_serverStats, gq_pinStats } from "views/stats/graph";

export const createProject = gql`
    mutation createProject($name: String!, $collectiontype: Int!, $language: String!, $country: String!, $projid: String!, $manager: String!){
        createProject(name: $name, collectiontype: $collectiontype, language: $language, country: $country, projid: $projid, manager: $manager){
            project{
                pid
            }
        }
    }`

export const createProjectQueries = compose(
    graphql(createProject, {
        options: {
            errorPolicy: "all"
        },
        name: "createProject"
        })
);

export const gq_getProject = gql`{
	currentProject{
		config
		extension
	}
}`

export const gq_getProjectDetails = gql`
    query project($pid:Int!){
        project(pid:$pid){
            name
            projid
            pid
            manager
            extension
            context
            language
            country
            active
        }
    }
`

export const gq_getConversationalPins = gql`
	query getConversationalData($pid: Int!, $filterBy: [JSONString], $offset: Int = 0, $pageSize: Int = 10, $sort: [JSONString]) {
	  getConversationalPins(pid: $pid, filterBy: $filterBy, offset: $offset, pageSize: $pageSize, sort: $sort) {
	    conversationalPins {
            pin
    	    confno
    	    part
    	    currentRecordingLength
    	    maxRecordingLength
    	  	pinConv {
    	      confirmation
    	      reset
    	      active
              user {
                username
              }
    	    }
        }, 
        pages
	  }
	}
`

export const getConversationalPinsQuery = compose(
  graphql(gq_getConversationalPins,{
    options: (props) => ({
            variables: {
                pid: props.match.params.id
            },
            errorPolicy: "all",
            fetchPolicy: 'cache-and-network'
    }),
    name: "getConversationalPinsQuery"
  })
);

export const getProjectsQuery = gql `
  query projects ($filterBy: [JSONString], $offset: Int = 0, $pageSize: Int = 10, $sort: [JSONString]) {
    projects (filterBy: $filterBy, offset: $offset, pageSize: $pageSize, sort: $sort) {
      projects {
        pid
        projid
        name
        extension
        collectiontype
        context
        language
        active
      }
      pages
    }
  }
`

export const withDataAndErrors = compose(
	graphql(getProjectsQuery,{
		options: () => ({
            variables: {
                q: ""
            },
            errorPolicy: "all",
            fetchPolicy: 'cache-and-network'
    }),
		name: "getProjects"
	})
);

export const generatePinQuery = gql`
    mutation generatePins($inputJson: String!) {
	  generatePins(inputJson: $inputJson) {
	    jsonObject
	  }
	}
	`
export const project = gql`
    query project($pid:Int!){
        project(pid:$pid){
            name
            projid
            pid
            manager
        }
    }
`

export const getProjectDetails = compose(
    graphql(gq_getProjectDetails, {
        options: (props) => ({
            variables: {
                pid: props.match.params.id
            },
            errorPolicy: "all"
        }),
        name: "getProjectDetails"
    }),
    graphql(gq_pinStats,{
        name: "getPinStatsQuery",
        options: {
            errorPolicy: "all",
            fetchPolicy: 'cache-and-network'
        },
    }),
    graphql(gq_serverStats,{
        name: "getServerStats",
        options: {
          errorPolicy: "all",
          fetchPolicy: "network-only"
        }
      })
);

export const generatePins = compose(
    graphql(generatePinQuery, {
        options: {
            errorPolicy: "all"
        },
        name: "generatePins"
        }),
    graphql(project,{
        options: (props) => ({
            variables: {
                pid: props.match.params.id
            },
            errorPolicy: "all",
            fetchPolicy: 'network'
    }),
    name: "project"
  })
);



// WEBPACK FOOTER //
// ./src/views/projects/graph.js